export class VisaStatus {
    visa_status_id ?= '';
    visa_status ?= '';
    visa_status_class ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/visa-status.ts